import { render, staticRenderFns } from "./RecommendedEvent.vue?vue&type=template&id=320cca11&scoped=true&"
import script from "./RecommendedEvent.vue?vue&type=script&lang=js&"
export * from "./RecommendedEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320cca11",
  null
  
)

export default component.exports